module.exports = __webpack_public_path__ + "img/warning_icon.1908c340.png";